/* =================== *
 * Generate OPM xlsx *
 * =================== */

import { axiosInstance } from "@/utils/lib/axios";
import { useMutation } from "@tanstack/react-query";
import waitForMediaCompletion from "./waitForMediaCompletion";
import { downloadBlobFile } from "@/utils/helper/downloadBlob";

async function generateOPMXlsx(
  id: string,
  entityId?: string,
  name?: string,
  evidencePath?: string,
): Promise<{ status: "SUCCESS" | "ERROR"; error?: string }> {
  const createResponse = await axiosInstance.get(
    `/bpmn/Rfs/opm/excel/download/${id}?evidencePath=${encodeURIComponent(
      evidencePath ?? "",
    )}&className=com.alurkerja.crud.historyupdatehomepass.HistoryUpdateHomepass&entityId=${entityId}`,
  );

  const result = await waitForMediaCompletion(
    `/api/crud/media/${createResponse.data.data.id}`,
  );

  if (result.success) {
    const downloadResponse = await axiosInstance.get(
      "/api/crud/media/download",
      {
        params: {
          path: result.path,
          fileName: name ?? result.originalFileName,
        },
        responseType: "blob",
      },
    );
    downloadBlobFile(
      new Blob([downloadResponse.data]),
      name ?? result.originalFileName,
    );
    return { status: "SUCCESS" };
  }

  return { status: "ERROR", error: result.error };
}
function useGenerateOPMXlsx() {
  return useMutation({
    mutationFn: ({
      id,
      entityId,
      name,
      evidencePath,
    }: {
      id: string;
      entityId?: string;
      name?: string;
      evidencePath?: string;
    }) => generateOPMXlsx(id, entityId, name, evidencePath),
  });
}

export { useGenerateOPMXlsx };
